const roleEx = [{
  desc: '添加自定义权限',
  options: {
    url: '/roleEx/editRoleEx',
    method: 'post'
  }
}, {
  desc: '查询自定义权限',
  options: {
    url: '/roleEx/queryRoleExByParentId',
    argsParams: true
  }
}, {
  desc: '根据商户版本查询角色',
  options: {
    url: '/roleEx/queryRoleMenuByParentId'
  }
}]
export default roleEx



// WEBPACK FOOTER //
// ./src/api/roleEx.js